import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "address-edit" }
const _hoisted_2 = { class: "address-edit__main" }
const _hoisted_3 = { class: "address-edit__content" }
const _hoisted_4 = { class: "address-edit__title" }
const _hoisted_5 = { class: "address-edit__field-group" }
const _hoisted_6 = { class: "address-edit__field-group" }
const _hoisted_7 = { class: "address-edit__field-split-container" }
const _hoisted_8 = { class: "address-edit__field-split" }
const _hoisted_9 = { class: "address-edit__field-split-group address-edit__field-shrink" }
const _hoisted_10 = { class: "address-edit__field-split-group" }
const _hoisted_11 = { class: "address-edit__field-group" }
const _hoisted_12 = {
  class: "address-edit__label",
  for: "country"
}
const _hoisted_13 = { class: "address-edit__content" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.25 4.5H3.75H15.75\" stroke=\"#1BB0A8\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5H14.25Z\" stroke=\"#1BB0A8\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.5 8.25V12.75\" stroke=\"#1BB0A8\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.5 8.25V12.75\" stroke=\"#1BB0A8\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_15 = { class: "address-edit__content" }
const _hoisted_16 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { fetchPageBuilder } from '@drapejs/core';
import * as bellaliteUser from '@/connectors/user';

import useUser from '@/composables/useUser';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { ERRORS } from '@/composables/constants';

import { FILEDS_CHARACTERS_LIMIT, addressTypes } from '../../../constants';
import { validateZipCode } from '@/helpers/utils';

import MyPagesBack from './MyPagesBack.vue';
import ErrorMessage from '../../forms/ErrorMessage.vue';
import Dropdown from '../../forms/Dropdown.vue';
import TextInput from '@/components/forms/TextInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressEdit',
  props: {
  addressType: {
    type: String,
    required: false,
  },
  addressData: {
    type: Object,
    required: false,
  },
},
  emits: ['saved', 'close-modal', 'back'],
  setup(__props, { emit }) {

const props = __props;





const { user } = useUser();
const { websiteText } = useWebsiteTexts();
const { channel, route, mitt, cart, navigateToLoginPage, invoke } =
  useContext();

const no = ref('');
const code = ref('');
const name = ref('');
const systemId = ref('');
const nameError = ref('');
const address = ref('');
const address2 = ref('');
const addressError = ref('');
const postCode = ref('');
const city = ref('');
const zipCityError = ref('');
const country = ref('');
const saveError = ref('');
const requestPending = ref(false);


const title = computed(() => {
  return props.addressType == addressTypes.billing
    ? websiteText('orderdetails__invoice_address').value
    : websiteText('checkout__delivery_address').value;
});

const countries = computed(() => {
  return user.value?.organization?.countries || [];
});

const isCareOfLengthExceeded = computed(
  () => (name.value?.length || 0) > FILEDS_CHARACTERS_LIMIT.careOf
);

const addressCharactersCount = computed(
  () => (address2.value?.length || 0) + (address.value?.length || 0)
);

const isAddressLengthExceeded = computed(
  () => addressCharactersCount.value > FILEDS_CHARACTERS_LIMIT.deliveryAddress
);

onMounted(() => {
  mitt.on('Remove:DeliveryAddress:Success', emitBack);
  no.value = props.addressData?.no;
  code.value = props.addressData?.code;
  systemId.value = props.addressData?.systemId;
  name.value = props.addressData?.name;
  address.value = props.addressData?.address;
  address2.value = props.addressData?.address2;
  postCode.value = props.addressData?.postCode;
  city.value = props.addressData?.city;
  country.value = props.addressData?.country || cart?.countryId || '';
});

onBeforeUnmount(() => {
  mitt.off('Remove:DeliveryAddress:Success', emitBack);
});

function validate() {
  if (!name.value) {
    nameError.value = websiteText('global__required_field').value;
    return false;
  }

  if (isCareOfLengthExceeded.value) {
    return;
  }

  if (!address.value) {
    addressError.value = websiteText('global__required_field').value;
    return false;
  }

  if (isAddressLengthExceeded.value) {
    return;
  }

  if (!postCode.value || !city.value) {
    console.error(postCode.value);

    zipCityError.value = websiteText('global__required_field').value;
    return false;
  }

  if (
    !validateZipCode(
      postCode.value,
      country.value,
      channel.value.countryRegexes
    )
  ) {
    zipCityError.value = websiteText('global__invalid_zip_code').value;
    return false;
  }

  return true;
}

async function save() {
  saveError.value = '';

  if (!validate()) {
    return;
  }

  if (props.addressType === addressTypes.billing) {
    await updateBillingAddress();
  } else if (props.addressType === addressTypes.shipping) {
    await addOrUpdateShippingAddress();
  }
}

async function updateBillingAddress() {
  const requestArgs = buildCommandArgs({
    no: no.value,
    name: name.value,
    address: address.value,
    address2: address2.value,
    postCode: postCode.value,
    city: city.value,
    country: country.value,
  });

  const response = await executeCommand(
    bellaliteUser.commands.updateBillingAddress,
    requestArgs
  );

  switch (response.error) {
    case ERRORS.NOT_AUTHENTICATED:
      navigateToLoginPage();
      break;
    case 'FAILED':
      saveError.value = websiteText('global__save_error').value;
      break;

    default:
      emit('saved');
      break;
  }
}

async function addOrUpdateShippingAddress() {

  const requestArgs = buildCommandArgs({
    no: no.value,
    code: code.value,
    systemId: systemId.value,
    name: name.value,
    address: address.value,
    address2: address2.value,
    postCode: postCode.value,
    city: city.value,
    country: country.value,
    saveOnOrganization: true,
  });

  const response = await executeCommand(
    bellaliteUser.commands.addOrUpdateShippingAddress,
    requestArgs
  );

  switch (response.error) {
    case 'FAILED':
      saveError.value = websiteText('global__save_error').value;
      break;

    default:
      emit('saved');
      break;
  }
}

function closeModal() {
  emit('close-modal');
}
function emitBack() {
  emit('back');
}

function buildCommandArgs(formArgs: any) {
  return {
    ...formArgs,
    ...fetchPageBuilder(
      route.protocol,
      route.host,
      route.pathname,
      { ...route.query },
      ''
    ),
  };
}

async function executeCommand(command: any, args: any) {
  try {
    requestPending.value = true;
    const response = await invoke(command, args);
    return response;
  } catch (err) {
    return [];
  } finally {
    requestPending.value = false;
  }
}

function openAddressRemoveModal() {
  mitt.emit('Remove:DeliveryAddress:Open', props.addressData);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPagesBack, {
        onBack: _cache[0] || (_cache[0] = ($event: any) => (emitBack())),
        onExit: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(title)), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextInput, {
            id: "name",
            type: "text",
            label: _unref(websiteText)('global_delivery_address_co').value,
            autocomplete: "organization",
            autoselect: true,
            modelValue: name.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((name).value = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (nameError.value = '')),
            "error-message": 
              _unref(isCareOfLengthExceeded)
                ? _unref(websiteText)('global__text_limit_exceeded').value
                : nameError.value
            ,
            showCharactersCount: true,
            hasCountError: _unref(isCareOfLengthExceeded),
            charactersCountText: 
              _unref(websiteText)('global__characters_count', {
                maxcharacters: _unref(FILEDS_CHARACTERS_LIMIT).careOf,
                count: name.value?.length || 0,
              }).value
            
          }, null, 8, ["label", "modelValue", "error-message", "hasCountError", "charactersCountText"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextInput, {
            id: "address",
            type: "text",
            label: _unref(websiteText)('global_delivery_address_address').value,
            autocomplete: "address-line1",
            modelValue: address.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((address).value = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (addressError.value = '')),
            "error-message": addressError.value,
            hasCountError: _unref(isAddressLengthExceeded)
          }, null, 8, ["label", "modelValue", "error-message", "hasCountError"]),
          _createVNode(TextInput, {
            id: "address2",
            type: "text",
            autocomplete: "address-line2",
            modelValue: address2.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((address2).value = $event)),
            showCharactersCount: true,
            hasCountError: _unref(isAddressLengthExceeded),
            "error-message": 
              _unref(isAddressLengthExceeded)
                ? _unref(websiteText)('global__text_limit_exceeded').value
                : ''
            ,
            charactersCountText: 
              _unref(websiteText)('global__characters_count', {
                maxcharacters: _unref(FILEDS_CHARACTERS_LIMIT).deliveryAddress,
                count: _unref(addressCharactersCount),
              }).value
            
          }, null, 8, ["modelValue", "hasCountError", "error-message", "charactersCountText"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(TextInput, {
                id: "postalCode",
                type: "text",
                label: _unref(websiteText)('global_delivery_address_address').value,
                autocomplete: "postal-code",
                modelValue: postCode.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((postCode).value = $event)),
                onInput: _cache[8] || (_cache[8] = ($event: any) => (zipCityError.value = '')),
                "error-message": zipCityError.value
              }, null, 8, ["label", "modelValue", "error-message"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(TextInput, {
                id: "city",
                type: "text",
                label: _unref(websiteText)('global_delivery_address_city').value,
                autocomplete: "home city",
                modelValue: city.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((city).value = $event)),
                onInput: _cache[10] || (_cache[10] = ($event: any) => (zipCityError.value = '')),
                "error-message": zipCityError.value
              }, null, 8, ["label", "modelValue", "error-message"])
            ])
          ]),
          (zipCityError.value)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                message: zipCityError.value
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(websiteText)('global_delivery_address_country').value), 1),
          _createVNode(Dropdown, {
            class: "address-edit__input",
            options: _unref(countries),
            modelValue: country.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((country).value = $event))
          }, null, 8, ["options", "modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (systemId.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "address-edit__remove",
            onClick: openAddressRemoveModal
          }, [
            _hoisted_14,
            _createElementVNode("div", null, _toDisplayString(_unref(websiteText)('global_delivery_address_remove').value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: "secondary-button address-edit__button-wide",
        onClick: save,
        disabled: requestPending.value
      }, _toDisplayString(_unref(websiteText)('global__save').value), 9, _hoisted_16),
      (saveError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: saveError.value
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})